import { SVGProps } from 'react';

function ToggleOnIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect y="3" width="36" height="18" rx="9" fill="#1A92FF" />
      <g filter="url(#filter0_d_5506_285)">
        <circle cx="26" cy="12" r="6" fill="white" />
      </g>
      <defs>
        <filter id="filter0_d_5506_285" x="14" y="0" width="24" height="24" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.172549 0 0 0 0 0.278431 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5506_285" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5506_285" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default ToggleOnIcon;
